import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { SIGNUP_PATH } from '../../lib/marketing';
import { track } from '../../lib/analytics';

export const StickyMobileCTA = () => {
  const { user } = useAuth();
  const [show, setShow] = useState(false);
  const [nearEnd, setNearEnd] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 480);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    const intersections = new Map();
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => intersections.set(entry.target, entry.isIntersecting));
      setNearEnd([...intersections.values()].some(Boolean));
    });
    document.querySelectorAll('footer, [data-mobile-cta-stop]').forEach((element) => observer.observe(element));
    return () => { window.removeEventListener('scroll', onScroll); observer.disconnect(); };
  }, []);
  if (user) return null;
  const visible = show && !nearEnd;
  return (
    <div aria-hidden={!visible} className={`mobile-sticky-cta fixed inset-x-0 bottom-0 z-40 p-3 transition-[transform,opacity] duration-300 md:hidden ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none invisible translate-y-full opacity-0'}`} style={{ paddingBottom: 'max(12px, env(safe-area-inset-bottom))' }}>
      <Link to={SIGNUP_PATH} data-testid="sticky-mobile-cta" onClick={() => track('hero_cta_click', { placement: 'sticky_mobile' })} tabIndex={visible ? 0 : -1}
        className="flex min-h-[52px] items-center justify-center gap-2 rounded-full bg-accent text-[15px] font-semibold text-accent-foreground shadow-[0_8px_24px_-6px_rgba(37,99,235,0.6)]">
        Build My Resume Free <ArrowRight className="h-4 w-4" aria-hidden="true" />
      </Link>
    </div>
  );
};
